import React from "react";
import { useParams } from "react-router-dom";
import CampaignsListPage from "./CampaignsListPage";
import CampaignDetailPage from "./CampaignDetailPage";

export default function Campaigns() {
  const params = useParams();
  return params?.id ? <CampaignDetailPage /> : <CampaignsListPage />;
}
